<div class="modal-content" style=" background-image: linear-gradient(to bottom, #e9f6ff , #b7defd );">
    <form #loginForm="ngForm" novalidate>
        <fieldset [disabled]="disableInput">
            <div class="modal-header">
            </div>
           
            <div class="modal-body">
                <div style="display: flex; justify-content: center; align-items: start; gap: 20px; margin-bottom: 20px;">
                    <img src="img/StemaBn.png" alt="Stema" style="max-height: 80px; object-fit: contain;">
                    <img src="img/geoportalBn.png" alt="Geoportal" style="max-height: 140px; object-fit: contain;">
                    <img src="img/BistritaTr.png" alt="Bistrita" style="max-height: 80px; object-fit: contain;">
                   
                </div>
                <div class="form-group">
                    <label for="name" i18n>Nume Utilizator</label>
                    <input type="text" class="form-control" id="username" #ui_username="ngModel" name="username" 
                    [(ngModel)]="username" (keyup.enter)="onEnterKeyPress(loginForm)" required>
                    <span *ngIf="loginForm.submitted || ui_username.touched">
                        <span *ngIf="ui_username.errors?.required" class="text-danger" i18n>Nume utilizator este obligatoriu</span>
                    </span>
                </div>
                <div class="form-group">
                    <label for="url" i18n>Parola</label>
                    <input type="password" class="form-control" id="password" #ui_password="ngModel" name="password"
                     [(ngModel)]="password" (keyup.enter)="onEnterKeyPress(loginForm)"  required>
                    <span *ngIf="loginForm.submitted || ui_password.touched">
                        <span *ngIf="ui_password.errors?.required" class="text-danger" i18n>Parola este obligatorie</span>
                    </span>
                </div>
                <div class="form-check">
                    <input type="checkbox" class="form-check-input" [(ngModel)]="rememberMe" id="rememberMe"> Menține-mă conectat
                </div>
            </div>
            <div class="form-group">
                <span *ngIf="errorResponse">
                    <span class="text-danger p-3">{{errorResponse}}</span>
                </span>
                <div *ngIf="disableInput === true" class="tool-spiner-box">
                    <i id="spinner" class="fa fa-circle-o-notch fa-spin tool-spiner"></i>
                </div>
            </div>
            <div class="form-group px-3">
                <button type="button" class="btn btn-success btn-block" [disabled]="!loginForm.valid" (click)="authenticate()" i18n>Conectare</button>
            </div>
            <div class="form-group px-3">
                <p class="text-center">Ai nevoie de ajutor? <a href="./suport-bn.html" target="_blank" i18n>Contactează suportul</a></p>
            
            </div>
            <div class="modal-footer text-center">
            </div>
        </fieldset>
    </form>
</div>

